// extracted by mini-css-extract-plugin
export var cellWithIconWrapper = "_03f579ca287b9013569a58d68e5cca21-css";
export var cellIcon = "f70600eef98918a694bc8a5f36de1f5a-css";